export var ModuleMetricsReporter = function (metricsReporter, module, seo) {
    if (seo === void 0) { seo = false; }
    var formatMetricName = function (metric) {
        var moduleName = seo ? "".concat(module.name, "-seo") : module.name;
        return "".concat(metric, "-").concat(moduleName);
    };
    return {
        meter: function (metricName) {
            return metricsReporter.meter(formatMetricName(metricName));
        },
        runAsyncAndReport: function (asyncMethod, methodName) {
            return metricsReporter.runAsyncAndReport(asyncMethod, formatMetricName(methodName));
        },
        reportError: function (err) {
            metricsReporter.meter(formatMetricName("error-".concat(err.name)));
            return metricsReporter.reportError(err);
        },
        histogram: function (metricName, value) {
            return metricsReporter.histogram(formatMetricName(metricName), value);
        }
    };
};
